export default __webpack_public_path__ + "static/media/Logo-Kakanj-Cement-BA.e49c314c.svg";